const weekdays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

export function useCalendarSettings({ customFirstDay } = {}) {
  const { sessionData: { calendar_settings: calendarSettings } } = useSessionData()

  let customFirstDayOfWeek

  if (customFirstDay !== undefined && weekdays.includes(customFirstDay.toLowerCase())) {
    customFirstDayOfWeek = (weekdays.indexOf(customFirstDay.toLowerCase()))
  }
  else {
    customFirstDayOfWeek = ![null, undefined].includes(calendarSettings.starting_day_of_week)
      ? weekdays.indexOf(calendarSettings.starting_day_of_week)
      : undefined
  }

  return {
    ...calendarSettings,
    customFirstDayOfWeek,
  }
}
